import React from 'react';
import { Download, Loader2 } from 'lucide-react';
export type ReportTab = 'patterns' | 'evidence' | 'recommendations' | 'conversation';
const TABS: {
  id: ReportTab;
  label: string;
}[] = [{
  id: 'patterns',
  label: 'Detailed analysis'
}, {
  id: 'evidence',
  label: 'Evidence'
}, {
  id: 'recommendations',
  label: 'Recommendations'
}, {
  id: 'conversation',
  label: 'Conversation'
}];
interface ReportTabsProps {
  active: ReportTab;
  onChange: (tab: ReportTab) => void;
  onDownloadPdf: () => void;
  isGeneratingPdf: boolean;
}
export function ReportTabs({
  active,
  onChange,
  onDownloadPdf,
  isGeneratingPdf
}: ReportTabsProps) {
  return <div className="flex items-stretch border-b border-forensic-line" data-id="element-348" data-mp="q3evo88y95fs">
      <div role="tablist" aria-label="Full report sections" className="flex min-w-0 flex-1 overflow-x-auto" data-id="element-349" data-mp="l5d9vfk52s0m">
        {TABS.map(tab => {
        const selected = tab.id === active;
        return <button key={tab.id} type="button" role="tab" id={`tab-${tab.id}`} aria-selected={selected} aria-controls={`panel-${tab.id}`} onClick={() => onChange(tab.id)} className={`-mb-px min-h-[48px] shrink-0 whitespace-nowrap border-b-2 px-4 text-sm font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:bg-white/[0.04] sm:px-5 ${selected ? 'border-forensic-crimson text-white' : 'border-transparent text-forensic-subtle hover:text-gray-200'}`} data-id="element-350" data-mp="35yqj0ty43493">
              {tab.label}
            </button>;
      })}
      </div>
      <button type="button" onClick={onDownloadPdf} disabled={isGeneratingPdf} aria-busy={isGeneratingPdf} className="ml-2 inline-flex min-h-[48px] shrink-0 items-center gap-2 whitespace-nowrap border-l border-forensic-line pl-4 pr-1 text-sm font-medium text-white transition-colors duration-150 ease-out hover:text-forensic-crimson-soft focus:outline-none focus-visible:bg-white/[0.04] disabled:cursor-wait disabled:opacity-70" data-id="element-351" data-mp="2ew88041rtoka">
        {isGeneratingPdf ? <Loader2 size={16} className="animate-spin" aria-hidden="true" data-id="element-352" data-mp="1c3cfgusmu18b" /> : <Download size={16} aria-hidden="true" data-id="element-353" data-mp="174j1z2dcia85" />}
        <span className="hidden sm:inline" data-id="element-354" data-mp="24r889of2z8zt">
          {isGeneratingPdf ? 'Preparing PDF…' : 'Download PDF'}
        </span>
        <span className="sm:hidden" data-id="element-355" data-mp="1zrlthajltkow">PDF</span>
      </button>
    </div>;
}